import React, { useState, useEffect, useRef } from "react";
import { Header } from "../components/Header.js";
import { Footer } from "../components/Footer.js";
import { Slide_title } from "../components/slide-title.js";
import t_shirt from "./../assets/img/t-shirt.png";
import { Link } from "react-router-dom";
import fill from "./../assets/img/fill.svg";
import upload from "./../assets/img/upload.svg";
import disc from "./../assets/img/disc.svg";
import remove from "./../assets/img/remove.svg";
import size from "./../assets/img/size.svg";
import user from "./../assets/img/user.svg";
import rebox from "./../assets/img/rebox.svg";
import pay from "./../assets/img/pay.svg";
import { Category_Header } from "../components/category-header.js";
import {
  addtocart_get_api,
  checkout_shipget_list_api,
  checkout_billget_list_api,
  checkout_preferences_api,
  place_order_api,
  gstdata_get_api,
  get_coupon_value_by_name,
  get_coupon_value_by_name_again,
  coupen_by_name_again,
} from "../service/api.js";
import Validation from "../components/validation.js";
import ErrorSnackbar from "../components/ErrorSnackbar.js";
import { useNavigate } from "react-router-dom";
import SuccessSnackbar from "../components/SuccessSnackbar.js";
import Head_CateHead from "../components/Head_CateHead.js";
import LoginPopup from "../components/LoginPopup.js";
import { AddressSection, ADDRESS_TYPES } from "../components/checkout/CheckoutAddress.js";

export const Checkout = () => {
  const navigate = useNavigate();
  const [api_data, setapi_data] = useState([]);
  const [ExceptionError, setExceptionError] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const [orderTotal, setOrderTotal] = useState(0);
  const [couponName, setcouponName] = useState("");
  const [ponumber, setponumber] = useState("");
  const [ponumber_err, setponumber_err] = useState("");
  const [getedCouponValue, setGetedCouponValue] = useState(0);

  useEffect(() => {
    const subtotal = api_data?.reduce(
      (total, item) => total + parseFloat(calculateSubtotal(item)),
      0
    );
    const gstAmount = parseFloat(calculateGST(subtotal));
    const totalAmount = subtotal + gstAmount;
    setOrderTotal(totalAmount);
  }, [api_data]);

  function handleExceptionError(res) {
    // alert("sf");
    setExceptionError((ExceptionError) => [
      ...ExceptionError,
      { id: Date.now(), message: res },
    ]);
  }
  function handleExceptionSuccessMessages(res) {
    if (res.Message) {
      setSuccessMessages((successMessages) => [
        ...successMessages,
        { id: Date.now(), message: res.Message },
      ]);
    }
  }
  function clearErrors(id) {
    setExceptionError((prevMessages) =>
      prevMessages.filter((msg) => msg.id !== id)
    );
  }
  function clearSuccess(id) {
    setSuccessMessages((prevMessages) =>
      prevMessages.filter((msg) => msg.id !== id)
    );
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const cartApiData = await addtocart_get_api();
        // Ensure that cartApiData.Data is an array before setting the state
        if (cartApiData?.Data?.length === 0) {
          navigate("/");
        } else {
          setapi_data(cartApiData.Data);
        }
        // Fetch the GST rate
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    };

      if (localStorage.getItem("token")) {
        fetchGST();
        fetchData();
      } else {
        setShowLoginPopup(true);
      }

      // Seed PO# field when arriving from Re Order flow
      const reorderOrderId = localStorage.getItem("reorderOrderId");
      if (reorderOrderId) {
        setponumber(reorderOrderId);
      }
  }, []);

  // Close handler — if user dismisses login popup without logging in, send to guest cart
  const handleLoginPopupClose = (val) => {
    setShowLoginPopup(val);
    if (!val && !localStorage.getItem("token")) {
      navigate("/guest-cart");
    }
  };

  // Function to handle unavailable images
  const getImageUrl = (item) => {
    return (
      process.env.REACT_APP_API_URL + item.ProductImage ||
      process.env.REACT_APP_API_URL + "default.jpg"
    );
  };
  // Calculate subtotal
  const calculateSubtotal = (item) => {
    // The same product can have several cart lines – add them all up
    const subtotal = (item.Carts || []).reduce(
      (total, c) => total + (c.QTY || 0) * (parseFloat(c.BasePrice) || 0),
      0
    );
    return subtotal.toFixed(2);
  };

  const [gstRate, setGSTRate] = useState(""); // Default value

  const fetchGST = async () => {
    try {
      const GSTData = await gstdata_get_api();
      // Set the fetched GST rate to a state variable
      setGSTRate(Number(GSTData.Data.Rate));
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };
  // Calculate GST
  const calculateGST = (subtotal) => {
    if (gstRate) {
      const gstTotal = subtotal * (gstRate / 100);
      return gstTotal.toFixed(2);
    } else {
      return 0;
    }
  };

  // ── Addresses come from the customer's address book ─────────────────────
  const [billingAddresses, setBillingAddresses] = useState([]);
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [selectedBilling, setSelectedBilling] = useState(null);
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [shipSameAsBilling, setShipSameAsBilling] = useState(false);
  const [addressError, setAddressError] = useState({ billing: false, shipping: false });
  const [unbrandedPackaging, setUnbrandedPackaging] = useState(false);
  const [placingOrder, setPlacingOrder] = useState(false);

  // Loads one address book and picks the address to use:
  //   selectId undefined -> the default (or most recent) address
  //   selectId "latest"  -> the address that was just added
  //   selectId <id>      -> that specific address (e.g. after editing it)
  const fetchAddresses = async (type, selectId) => {
    try {
      const res =
        type === "billing"
          ? await checkout_billget_list_api()
          : await checkout_shipget_list_api();
      const list = Array.isArray(res?.Data) ? res.Data : [];
      const idKey = ADDRESS_TYPES[type].idKey;

      let chosen = null;
      if (selectId === "latest") {
        chosen = list.reduce(
          (latest, a) => (!latest || a[idKey] > latest[idKey] ? a : latest),
          null
        );
      } else if (selectId) {
        chosen = list.find((a) => String(a[idKey]) === String(selectId)) || null;
      }
      if (!chosen) {
        chosen = list.find((a) => a.IsDefault) || list[list.length - 1] || null;
      }

      if (type === "billing") {
        setBillingAddresses(list);
        setSelectedBilling(chosen);
      } else {
        setShippingAddresses(list);
        setSelectedShipping(chosen);
      }
      setAddressError((prev) => ({ ...prev, [type]: false }));
      return list;
    } catch (error) {
      console.error("Error loading " + type + " addresses:", error);
      return [];
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) return;
    const loadCheckoutDefaults = async () => {
      const [, shippingList] = await Promise.all([
        fetchAddresses("billing"),
        fetchAddresses("shipping"),
      ]);
      // Customers with no delivery address saved yet can simply ship to billing
      if (shippingList.length === 0) setShipSameAsBilling(true);

      try {
        const prefs = await checkout_preferences_api();
        setUnbrandedPackaging(!!prefs?.Data?.UnbrandedPackaging);
      } catch (error) {
        console.error("Error loading checkout preferences:", error);
      }
    };
    loadCheckoutDefaults();
  }, []);

  const [Subtotal, setSubtotal] = useState("");
  const [gstAmount, setGstAmount] = useState("");
  useEffect(() => {
    let priceArray = [];
    if (api_data) {
      api_data?.map((product) =>
        product?.Carts?.map((cart) => {
          priceArray.push(Number(cart?.BasePrice * cart?.QTY));
        })
      );
    }
    const CalSubtotal = parseFloat(
      priceArray?.reduce((sum, item) => sum + item, 0)
    ).toFixed(2);
    if (CalSubtotal) {
      setSubtotal(CalSubtotal);
      // if (CalSubtotal && getedCouponValue) {
      //     const withCoupon = parseFloat(CalSubtotal - getedCouponValue * CalSubtotal / 100)
      //     setSubtotal(withCoupon)
      // }
    }
    if (gstRate) {
      const withGst = parseFloat(((CalSubtotal * gstRate) / 100).toFixed(2));
      setGstAmount(withGst);
      // if (gstRate && getedCouponValue) {
      //     const withCoupon = parseFloat((CalSubtotal - (getedCouponValue * CalSubtotal / 100)) * gstRate / 100)
      //     setGstAmount(withCoupon)
      // }
    }
  }, [api_data, getedCouponValue, gstRate]);
  const priceAfterDiscount = (Subtotal * getedCouponValue) / 100;
  const gstWithCoupen = ((Subtotal - priceAfterDiscount) * gstRate) / 100;

  const handleplaceorder = async () => {
    if (placingOrder) return;

    const billing = selectedBilling;
    const shipping = shipSameAsBilling ? null : selectedShipping;
    const missing = {
      billing: !billing,
      shipping: !shipSameAsBilling && !shipping,
    };
    setAddressError(missing);
    if (missing.billing || missing.shipping) {
      handleExceptionError(
        missing.billing
          ? "Please add or choose a billing address"
          : "Please add or choose a shipping address"
      );
      return;
    }
    if (!billing.BEmail || !billing.BMobileNumber) {
      handleExceptionError(
        "Your billing address needs an email and mobile number. Please edit it."
      );
      return;
    }

    const text = (address, key) => address?.[key] ?? "";
    const shipTo = shipSameAsBilling
      ? {
          SCustomerName: text(billing, "BCustomerName"),
          SCountry: text(billing, "BCountry"),
          SState: text(billing, "BState"),
          SCity: text(billing, "BCity"),
          SAddress1: text(billing, "BAddress1"),
          SAddress2: text(billing, "BAddress2"),
          SZipcode: text(billing, "BZipcode"),
        }
      : {
          SCustomerName: text(shipping, "SCustomerName"),
          SCountry: text(shipping, "SCountry"),
          SState: text(shipping, "SState"),
          SCity: text(shipping, "SCity"),
          SAddress1: text(shipping, "SAddress1"),
          SAddress2: text(shipping, "SAddress2"),
          SZipcode: text(shipping, "SZipcode"),
        };

    const data = {
      BCustomerName: text(billing, "BCustomerName"),
      BCountry: text(billing, "BCountry"),
      BState: text(billing, "BState"),
      BCity: text(billing, "BCity"),
      BAddress1: text(billing, "BAddress1"),
      BAddress2: text(billing, "BAddress2"),
      BZipcode: String(text(billing, "BZipcode")),
      BEmail: text(billing, "BEmail"),
      BMobileNumber: text(billing, "BMobileNumber"),
      ...shipTo,
      SZipcode: String(shipTo.SZipcode),
      Totalprice: (parseFloat(Subtotal) + parseFloat(gstAmount)).toFixed(2),
      PaymentMethod: "Credit Card",
      IpAddress: "192.168.1.1",
      SpliteOrder: false,
      GSTAmount: gstAmount,
      GSTText: gstRate,
      CouponName: couponName,
      CouponValue: getedCouponValue,
      ponumber: ponumber,
      UnbrandedPackaging: unbrandedPackaging,
    };

    setPlacingOrder(true);
    try {
      const res = await place_order_api({ ...data });
      if (res.status === 200) {
        localStorage.removeItem("couponName");
        localStorage.removeItem("reorderOrderId");
        setTimeout(() => {
          navigate("/thanks_order");
        }, 1000);
        return;
      }
    } catch (error) {
      const message = error?.response?.data?.ErrorMessage;
      handleExceptionError(
        typeof message === "string" ? message : "Unable to place your order. Please try again."
      );
    }
    setPlacingOrder(false);
  };

  const [errors, setErrors] = useState({});

  const [expandedShirt, setExpandedShirt] = useState({}); // { [cartId]: true/false }
  // function handleValidation(event) {
  //   event.preventDefault();
  //   const validationErrors = Validation(values); // Pass the values object directly
  //   setErrors(validationErrors);
  // }

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      setShowLoginPopup(true);
    }
  }, [errors]);
  const [couponName1, setcouponName1] = useState();

  const applyCoupon = async (data) => {
    if (couponName) {
      try {
        const res = await get_coupon_value_by_name({ CouponName: couponName });
        if (res.status === true) {
          setGetedCouponValue(res.value);
          setcouponName1(couponName);
          localStorage.setItem("couponName", couponName);
        }
      } catch (error) {
        console.error("err ", error);
      }
    } else {
      try {
        const res = await get_coupon_value_by_name({ CouponName: data });
        if (res.status === true) {
          setGetedCouponValue(res.value);
          setcouponName1(data);
          localStorage.setItem("couponName", data);
        }
      } catch (error) {}
    }
  };
  const applyonRefresh = async (data) => {
    if (couponName) {
      try {
        const res = await coupen_by_name_again({ CouponName: couponName });
        if (res.status === true) {
          setGetedCouponValue(res.value);
          setcouponName1(couponName);
          localStorage.setItem("couponName", couponName);
        }
      } catch (error) {
        console.error("err ", error);
      }
    } else {
      try {
        const res = await coupen_by_name_again({ CouponName: data });
        if (res.status === true) {
          setGetedCouponValue(res.value);
          setcouponName1(data);
          localStorage.setItem("couponName", data);
        }
      } catch (error) {}
    }
  };
  useEffect(() => {
    if (localStorage.getItem("couponName")) {
      applyonRefresh(localStorage.getItem("couponName"));
    }
  }, [localStorage.getItem("couponName")]);
  return (
    <div>
      {showLoginPopup && <LoginPopup setLogin={handleLoginPopupClose} hideClose={true} />}
      <ErrorSnackbar
        errorMessages={ExceptionError}
        onClearErrors={clearErrors}
      />
      {/* <SuccessSnackbar
                successMessages={successMessages}
                onclearSuccess={clearSuccess}
            /> */}
      <Head_CateHead />
      <div className="container">
        <Slide_title title="Checkout" className="category_title checkout" />
        <div className="checkout_wrapper">
          <div className="checkout_detail_form mb-4">
            <AddressSection
              type="billing"
              title="Billing Address"
              addresses={billingAddresses}
              selected={selectedBilling}
              onSelect={(address) => {
                setSelectedBilling(address);
                setAddressError((prev) => ({ ...prev, billing: false }));
              }}
              onChanged={fetchAddresses}
              hasError={addressError.billing}
            />

            <AddressSection
              type="shipping"
              title="Shipping Address"
              addresses={shippingAddresses}
              selected={selectedShipping}
              onSelect={(address) => {
                setSelectedShipping(address);
                setAddressError((prev) => ({ ...prev, shipping: false }));
              }}
              onChanged={fetchAddresses}
              mirror={shipSameAsBilling ? selectedBilling : null}
              hasError={addressError.shipping}
            >
              <label className="co-same-as">
                <input
                  type="checkbox"
                  checked={shipSameAsBilling}
                  onChange={(e) => {
                    setShipSameAsBilling(e.target.checked);
                    setAddressError((prev) => ({ ...prev, shipping: false }));
                  }}
                />
                Shipping address is the same as billing address
              </label>
            </AddressSection>

            <div className="co-packaging">
              <span>Do you require unbranded packaging?</span>
              <div className="co-packaging-options">
                <label>
                  <input
                    type="radio"
                    name="unbranded_packaging"
                    checked={!unbrandedPackaging}
                    onChange={() => setUnbrandedPackaging(false)}
                  />
                  No
                </label>
                <label>
                  <input
                    type="radio"
                    name="unbranded_packaging"
                    checked={unbrandedPackaging}
                    onChange={() => setUnbrandedPackaging(true)}
                  />
                  Yes
                </label>
              </div>
              <p className="co-packaging-note">
                Your choice is saved to your account as the default for future orders. You
                can change it here at any time.
              </p>
            </div>
          </div>
          <div className="checkout_order_summary">
            <div className="cart_list checkout">
              {api_data.map((item) => {
                return (
                  <>
                  {
                    item.Carts.length > 0 && item.Carts.map((cartItem)=> {
                      return(
                        <>
                  <div className="cart_item" key={cartItem.CartID}>
                    <div className="cart_img checkout">
                      {/* Use item.ProductImage here */}
                      <img src={getImageUrl(item)} alt={cartItem.ProductName} />
                    </div>
                    <div className="cart_info">
                      <div className="cart_info1 checkout">
                        <div className="cart_detail">
                          <div className="cart_title">
                            <h3>{cartItem.ProductName}</h3>
                            <Link
                              to={`/product/${item.Slug}?edit=${cartItem.CartID}`}
                              style={{
                                color: "#01AEF0",
                                fontSize: "13px",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                textDecoration: "underline",
                              }}
                            >
                              Edit
                            </Link>
                            {cartItem.randomnumber != "" &&
                              cartItem.randomnumber != null && (
                                <p>
                                  {cartItem?.randomnumber?.map(
                                    (randomnumber, i) => {
                                      return (
                                        <span className="sm-txt" key={i}>
                                          {randomnumber.name}(
                                          {randomnumber.value}){" "}
                                        </span>
                                      );
                                    }
                                  )}
                                </p>
                              )}
                            {
                              cartItem?.CartSetupPrice?.length > 0 && (
                                <>
                                  <h3 style={{ marginTop: "12px" }}>
                                    Additional Cost:
                                  </h3>
                                  <p>
                                    {cartItem.CartSetupPrice.filter(
                                      (setp) =>
                                        parseFloat(
                                          setp.QTY
                                        ) > 0
                                    ).map((setp, i) => (
                                      <span className="sm-txt" key={i}>
                                        {setp.ProductSetupPrice.SetupName} (
                                        {parseFloat(setp.QTY)}){" "}
                                      </span>
                                    ))}
                                  </p>
                                </>
                              )}
                          </div>
                          <div className="cart_price">
                            <h5>
                              $
                              {(
                               cartItem.BasePrice * cartItem.QTY
                              ).toFixed(2)}
                            </h5>
                          </div>
                        </div>
                      </div>
                      {/* ShirtDescription — full width below image/title/price row */}
                      {cartItem.ShirtDescription && (() => {
                        let parsed = null;
                        try {
                          parsed = typeof cartItem.ShirtDescription === "string"
                            ? JSON.parse(cartItem.ShirtDescription)
                            : cartItem.ShirtDescription;
                        } catch (e) { return null; }
                        const teamName = parsed && !Array.isArray(parsed) && parsed.teamName ? parsed.teamName : "";
                        const shirtRows = parsed && !Array.isArray(parsed) && Array.isArray(parsed.players)
                          ? parsed.players
                          : Array.isArray(parsed) ? parsed : [];
                        if (shirtRows.length === 0) return null;
                        const isExpanded = !!expandedShirt[cartItem.CartID];
                        const visibleRows = isExpanded ? shirtRows : shirtRows.slice(0, 2);
                        return (
                          <div style={{ width: "100%", marginTop: "10px", marginBottom: "6px" }}>
                            {teamName && (
                              <p style={{ fontFamily: "Poppins", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#333" }}>
                                Team Name: <span style={{ fontWeight: "400", color: "#555" }}>{teamName}</span>
                              </p>
                            )}
                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.8rem", fontFamily: "Poppins" }}>
                              <thead>
                                <tr style={{ background: "rgba(3,128,176,0.08)" }}>
                                  <th style={{ padding: "5px 8px", textAlign: "left", fontWeight: "600", borderBottom: "1px solid #ddd" }}>Variation</th>
                                  <th style={{ padding: "5px 8px", textAlign: "left", fontWeight: "600", borderBottom: "1px solid #ddd" }}>Name</th>
                                  <th style={{ padding: "5px 8px", textAlign: "left", fontWeight: "600", borderBottom: "1px solid #ddd" }}>Number</th>
                                </tr>
                              </thead>
                              <tbody>
                                {visibleRows.map((row, ri) => (
                                  <tr key={ri} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                    <td style={{ padding: "4px 8px", color: "#555" }}>{row.variation}</td>
                                    <td style={{ padding: "4px 8px", color: "#555" }}>{row.name}</td>
                                    <td style={{ padding: "4px 8px", color: "#555" }}>{row.number}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {shirtRows.length > 2 && (
                              <span
                                className="txt_read_more"
                                style={{ cursor: "pointer", fontSize: "0.8rem", fontFamily: "Poppins" }}
                                onClick={() =>
                                  setExpandedShirt((prev) => ({
                                    ...prev,
                                    [cartItem.CartID]: !prev[cartItem.CartID],
                                  }))
                                }
                              >
                                {isExpanded ? "Read Less" : `+${shirtRows.length - 2} more... Read More`}
                              </span>
                            )}
                          </div>
                        );
                      })()}
                      {/* Custom Popup Details */}
                      {cartItem.custompopup && (() => {
                        let parsed = null;
                        try {
                          parsed = typeof cartItem.custompopup === "string"
                            ? JSON.parse(cartItem.custompopup)
                            : cartItem.custompopup;
                        } catch (e) { return null; }
                        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
                        const entries = Object.entries(parsed);
                        if (entries.length === 0) return null;
                        return (
                          <div style={{ width: "100%", marginTop: "10px", marginBottom: "6px", background: "#f9f9f9", borderRadius: "6px", padding: "10px 12px" }}>
                            <p style={{ fontFamily: "Poppins", fontSize: "0.85rem", fontWeight: "600", marginBottom: "8px", color: "#333" }}>
                              Custom Details:
                            </p>
                            {entries.map(([key, val], i) => (
                              <div key={i} style={{ display: "flex", gap: "8px", marginBottom: "4px", fontFamily: "Poppins", fontSize: "0.8rem" }}>
                                <span style={{ fontWeight: "500", color: "#444", minWidth: "120px" }}>{key}:</span>
                                <span style={{ color: "#555" }}>
                                  {typeof val === "boolean" ? (val ? "✓ Yes" : "✗ No") : String(val)}
                                </span>
                              </div>
                            ))}
                          </div>
                        );
                      })()}

                      <div className="cart_info2 checkout">
                        <div className="cart_count checkout">
                          <h4>
                            QTY: {cartItem.QTY} X {cartItem.BasePrice}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="cart_item_space checkout" />
                </>
                      )
                    })
                  }
                  </>
                )
              }
                
              )}
            </div>

            <div className="total-summary checkout">
              <h4>PO# or Order reference number</h4>
              <div className="discount_code">
                <input
                  type="text"
                  value={ponumber}
                  name="PO"
                  id=""
                  onChange={(e) => {
                    setponumber(e.target.value);
                    setponumber_err("");
                  }}
                />
                <p style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {ponumber_err}
                </p>
              </div>
              <h4>Discount code</h4>
              <div className="discount_code">
                <input
                  type="text"
                  value={couponName}
                  name="CouponName"
                  id=""
                  onChange={(e) => {
                    setcouponName(e.target.value);
                  }}
                />
                <button
                  className={
                    couponName ? "active-color-size-qty-btn" : "bg_gray"
                  }
                  disabled={!couponName}
                  onClick={applyCoupon}
                >
                  Apply
                </button>
              </div>
              <div className="cart_total checkout">
                <div className="cart_title">
                  <h3>Order Summary</h3>
                </div>
                <div className="cart_total_list">
                  <div className="cart_count1">
                    <h3>Subtotal</h3>
                    <h4>${parseFloat(Subtotal).toFixed(2)}</h4>
                  </div>
                  <hr className="cart_total_hr" />
                  {getedCouponValue > 0 && (
                    <>
                      <div className="cart_count1">
                        <h3>
                          Coupon Discount : "{couponName1}({getedCouponValue}%)"
                        </h3>
                        <h4>-${priceAfterDiscount.toFixed(2)}</h4>
                      </div>
                      <hr className="cart_total_hr" />
                    </>
                  )}
                  {getedCouponValue > 0 ? (
                    <div className="cart_count1">
                      <h3>GST ({gstRate}%)</h3>
                      <h4>${gstWithCoupen.toFixed(2)}</h4>
                    </div>
                  ) : (
                    <div className="cart_count1">
                      <h3>GST ({gstRate}%)</h3>
                      <h4>${parseFloat(gstAmount).toFixed(2)}</h4>
                    </div>
                  )}

                  <hr className="cart_total_hr" />
                  {getedCouponValue > 0 ? (
                    <div className="cart_count1">
                      <h3>Order total</h3>
                      <h4>
                        $
                        {(
                          parseFloat(Subtotal) -
                          (Subtotal * getedCouponValue) / 100 +
                          parseFloat(gstWithCoupen)
                        ).toFixed(2)}
                      </h4>
                    </div>
                  ) : (
                    <div className="cart_count1">
                      <h3>Order total</h3>
                      <h4>
                        $
                        {(
                          parseFloat(Subtotal) -
                          (Subtotal * getedCouponValue) / 100 +
                          parseFloat(gstAmount)
                        ).toFixed(2)}
                      </h4>
                    </div>
                  )}
                </div>
                <button
                  onClick={handleplaceorder}
                  disabled={placingOrder}
                  // style={{
                  //   backgroundColor: (!selectedShippingAddress || !selectedBillingAddress)
                  //     ? 'gray'
                  //     : '',
                  //   color: 'white',
                  // }}
                >
                  Place Order
                </button>

                <p>
                  Learn more <a href="#">Taxes</a> and <a href="#">Shipping</a>{" "}
                  information
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
